const wrapCountFn = (num) => {
  if (num === undefined || num === null) return '0'
  
  let result = ''
  const number = Number(num)
  
  if (number <= 999) {
    // X= (0, 999], 展示对应数字
    result = String(number)
  } else if (number >= 1000 && number <= 9999) {
    // X=[1000,9999], X/1000, 保留1位小数, 展k单位
    result = Math.floor(number / 100) / 10 + 'k'
  } else if (number > 9999) {
    // X>9999, X/10000, 保留1位小数, 展示w单位
    result = Math.floor(number / 1000) / 10 + 'w'
  }
  
  return result
}

export default {
  computed: {
    trackGameInfo () {
      const { gameId, gameName } = this.gameInfo
      return {
        appkey: gameId,
        appName: gameName,
      }
    },
    isWx () {
      return this.$route.query.app * 1 === 0
    },
  },
  methods: {
    wrapCountFn,
    onTrack (name, params = {}) {
      this.eventTrack({
        event: name,
        event_field: JSON.stringify(params),
        ...this.trackGameInfo,
      })
    },
    goGameDetail () {
      setTimeout(() => {
        this.handleGoDownload(this.gameInfo.gameId, this.isWx ? 70 : 42)
      }, 130)
    },
  },
}